import { zoomPlugin } from "@react-pdf-viewer/zoom";
import { Card, CardBody, Col } from "reactstrap";
import { Worker, Viewer } from '@react-pdf-viewer/core';

const BerkasViewer = ({berkas}) => {

    const zoomPluginInstance = zoomPlugin();
    const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;

  return (
    <Col md="6">
      <Card className="h-100">
        <CardBody style={{ height: "350px" }}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0">Berkas</h5>
            {berkas && (
              <div className="d-flex gap-2">
                <ZoomOutButton />
                <ZoomPopover />
                <ZoomInButton />
              </div>
            )}
          </div>
          {berkas && (
            <div
              className="pdf-viewer-container"
              style={{ height: "300px", overflow: "auto" }}
            >
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                <Viewer
                  fileUrl={URL.createObjectURL(berkas)}
                  defaultScale={0.8}
                  plugins={[zoomPluginInstance]}
                />
              </Worker>
            </div>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default BerkasViewer;
